import { render } from "./MonthlyProductSales.vue?vue&type=template&id=202bc8c2&scoped=true"
import script from "./MonthlyProductSales.vue?vue&type=script&lang=js"
export * from "./MonthlyProductSales.vue?vue&type=script&lang=js"

import "./MonthlyProductSales.vue?vue&type=style&index=0&id=202bc8c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202bc8c2"]])

export default __exports__